export default __webpack_public_path__ + "static/media/2_0012.46c1dbb4.webp";